export const ModelListBR = [
    {
        'group':'Renco',
        'name':'Google',
        'models':
        [
            // {name:'SATELLITEO',url:'./models/satellite2.glb'},
            {name:'SATELLITE',url:'./models/googleLayout.glb'},
            {name:'SATELLITE_TR',url:'./models/googleLayout_tr.glb'},
        ]   

    },
    {
        'group':'Renco',
        'name':'Development',
        'models':
        [
       
            {name:'Surface_Topo',url:'./models/surface_topo.glb'},
            {name:'Underground_development',url:'./models/underground_development.glb'},
            {name:'Underground_workings',url:'./models/ug_workings.glb'},
            {name:'Shafts',url:'./models/Renco_shafts.glb'},
            {name:'Raises',url:'./models/renco_raises.glb'},
            {name:'Haulages',url:'./models/Renco_haulages.glb'},
            {name:'Drives',url:'./models/Renco_drives.glb'},
            {name:'Planned_Dev',url:'./models/Renco_planned_development.glb'},
            {name:'068',url:'./models/068.glb'},
            {name:'690',url:'./models/690.glb' },
            {name:'810',url:'./models/810.glb' },
            {name:'891',url:'./models/891.glb' },
            {name:'ed',url:'./models/ed.glb' },
            {name:'Raises',url:'./models/renco_raises.glb' },
            {name:'spot_drive',url:'./models/spot_drive.glb' },


            
        ]   

    },
    {
        'group':'Renco',
        'name':'Orebody',
        'models':
        [            
            {name:'Reef1',url:'./models/Renco_reefs1.glb' },
            {name:'Reef2',url:'./models/Renco_reefs2.glb' },
            {name:'Reef3',url:'./models/Renco_reefs3.glb' },
            {name:'Reef4',url:'./models/Renco_reefs4.glb' },
            {name:'Reef5',url:'./models/Renco_reefs5.glb' },
            {name:'rm',url:'./models/rm.glb' },
            {name:'mod_reef',url:'./models/mod_reef.glb' },
            {name:'renco_east',url:'./models/renco_east.glb' },
            {name:'renco_reef',url:'./models/renco_reef.glb' },
            {name:'spot_reef',url:'./models/spot_reef.glb' },
            ]   

    },

   
    
    {
        'group':'Holes',
        'name':'Holes',
        'models':
        [
            {type:'holesassays',name:'DrilledHoles',assay_url:'./files/AssayData.csv' , hole_url:'./files/HoleData.csv'},
            {name:'UG_Holes',url:'./models/Renco_UG_holes.glb' },
            {name:'Surface_DD',url:'./models/Renco_Surface_DD.glb' },           
        
        ]   

    }
]